<div
  style="
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    flex-wrap: wrap;
    padding-bottom: 50px;
  "
>
  <div style="width: 95%">
    @if (content && !isEditing) {
      <div style="display: flex">
        <app-comment [text]="content"></app-comment>
        <button (click)="isEditing = true" class="edit-icon-btn" mat-button>
          <mat-icon class="just-icon">edit</mat-icon>
        </button>
      </div>
    }
    @if (isEditing) {
      <div>
        <div style="flex-basis: 100%">
          <form>
            <mat-form-field style="width: 100%">
              <mat-label>Place your comment here...</mat-label>
              <textarea
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMaxRows="100"
                cdkAutosizeMinRows="1"
                cdkTextareaAutosize
                matInput
                (keyup)="onInputKeyUp($event)"
                [value]="content"
              ></textarea>
            </mat-form-field>
          </form>
        </div>
        @if (content !== null) {
          <div style="flex-basis: 100%">
            <div style="display: flex; flex-direction: row; justify-content: right">
              <span style="flex: 1 0 auto"></span>
              <button class="btn-cancel-comment" mat-button (click)="onCancelComment()">Cancel</button>
              <button class="btn-add-comment" [class.spinner]="isUpdating" mat-button (click)="onUpdateComment()">Save</button>
            </div>
          </div>
        }
      </div>
    }
    @if (!isEditing) {
      <mat-divider style="margin-top: 20px; margin-bottom: 20px"></mat-divider>
    }
  </div>
</div>
